import React from 'react';

export default function PartnerCard({ employee }) {
  return <div className="partner-card"></div>;
}
